export function pxToRem(px:number, base = 16):string {
    return `${px / base}rem`;
  }

  export const AppSize={
    padding:80,
    padding2:75
  }

  export const NAVHEIGHT=84;